var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 43,
    viewBox: "0 0 43 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 6.71875C11.8523 6.71875 4.03125 14.5398 4.03125 24.1875C4.03125 33.8352 11.8523 41.6562 21.5 41.6562C31.1477 41.6562 38.9688 33.8352 38.9688 24.1875C38.9688 14.5398 31.1477 6.71875 21.5 6.71875ZM31.9519 34.6394C29.5338 37.0576 26.3521 38.5624 22.9488 38.8976C19.5456 39.2328 16.1314 38.3776 13.288 36.4777C10.4446 34.5778 8.34793 31.7508 7.35523 28.4783C6.36254 25.2059 6.53523 21.6904 7.84389 18.531C9.15256 15.3716 11.5162 12.7637 14.5321 11.1517C17.5481 9.5396 21.0296 9.02315 24.3836 9.6903C27.7377 10.3574 30.7566 12.1669 32.926 14.8104C35.0955 17.4539 36.2812 20.7678 36.2812 24.1875C36.2865 26.1294 35.9066 28.053 35.1635 29.8471C34.4204 31.6412 33.3288 33.2701 31.9519 34.6394Z",
    fill: "#006838"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.8408 13.4375H20.1533V24.8333L27.3764 30.6118L29.0553 28.5132L22.8408 23.5416V13.4375ZM1.92578 9.64105L14.6914 0.906677L16.2091 3.12479L3.44346 11.8592L1.92578 9.64105ZM26.7853 3.1247L28.3029 0.906677L41.0685 9.64122L39.5509 11.8592L26.7853 3.1247Z",
    fill: "#006838"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.1b87922ffb46ecb84096f2b369be94b7.svg";
export { ForwardRef as ReactComponent };